"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_KEYS_PROJECT_LIMIT = 5;
exports.QUOTA_LIMIT = 15000;
//# sourceMappingURL=index.js.map